module.exports = __webpack_public_path__ + "icon_config_100white.fe310.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/icon_config_100white.svg
// module id = ./src/_asset/sources/assets/images/@svg/icon_config_100white.svg
// module chunks = main